import { createContext } from "react";

export const ToggleNavContext = createContext({})